// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"loading-screen_wrapper__un3n2","bar":"loading-screen_bar__C9zsF","progress":"loading-screen_progress__1z8ZH","imageWrapper":"loading-screen_imageWrapper__1vWhF"};